import { ArrowLineDown, ArrowLineUp, X } from '@phosphor-icons/react';

/**
 * A lightweight chooser shown when the customer taps "Transfer": pick a direction (deposit into TACH
 * vs. withdraw to their bank), then branch into the matching modal. Each option carries a one-line
 * description because money-movement direction is easy to confuse.
 */
export const TransferChooserModal = ({
  isOpen,
  onClose,
  onSelectDeposit,
  onSelectWithdraw,
}: {
  isOpen: boolean;
  onClose: () => void;
  onSelectDeposit: () => void;
  onSelectWithdraw: () => void;
}) => {
  if (!isOpen) return null;

  const options = [
    {
      key: 'deposit',
      icon: <ArrowLineDown size={22} className="text-secondary" />,
      title: 'Deposit into TACH',
      description:
        'Move money from your Plaid-linked bank into your TACH account.',
      onClick: onSelectDeposit,
    },
    {
      key: 'withdraw',
      icon: <ArrowLineUp size={22} className="text-primary" />,
      title: 'Withdraw from TACH',
      description: 'Move money from TACH to your linked bank account.',
      onClick: onSelectWithdraw,
    },
  ];

  return (
    <div
      className="fixed inset-0 z-40 flex items-center justify-center bg-gray-900 bg-opacity-50"
      onClick={onClose}
    >
      <div
        className="w-[95%] max-w-[420px] overflow-hidden rounded-[4px] bg-white"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex h-[56px] items-center justify-between p-4">
          <h2 className="text-[16px] font-[600] text-primary">Transfer</h2>
          <X
            className="hover:cursor-pointer hover:opacity-80"
            onClick={onClose}
            weight="regular"
            size={24}
          />
        </div>
        <div className="flex flex-col gap-3 border-t border-bordergray p-6">
          {options.map((o) => (
            <button
              key={o.key}
              type="button"
              onClick={o.onClick}
              className="flex w-full items-center gap-3 rounded-[8px] border border-bordergray p-4 text-left transition-colors hover:border-accent hover:bg-bgyellow"
            >
              <div className="flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full bg-primarybg">
                {o.icon}
              </div>
              <div className="flex flex-col">
                <p className="text-[15px] font-[600] text-primary">
                  {o.title}
                </p>
                <p className="text-[13px] text-graysecondary">
                  {o.description}
                </p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TransferChooserModal;
